const frequencyLabelMap: { [key: string]: string } = {
  incomplete: 'Incomplete',
  pending_review: 'Pending Review',
  reviewed: 'Reviewed'
}

export const getReportStatusLabel = (name: string) => frequencyLabelMap[name] || name
